import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/**
 * Check if email is valid or not.
 *
 * @returns {ValidatorFn}
 */
export function validateEmail(): ValidatorFn {


    // Create Regex Pattern
    let regexPattern = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$');

    return (control: AbstractControl): { [key: string]: any } => {

        if (!control.value) {

            return null;
        }

        if (regexPattern.test(control.value)) {

            return null;
        }

        return {'validateEmail': {value: control.value}};
    };

}


@Directive({
    selector: '[validateEmail]',
    providers: [{provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true}]
})
export class EmailValidatorDirective implements Validator {
    @Input()
    length: string;

    validate(control: AbstractControl): { [key: string]: any } {

        return validateEmail()(control);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/email-validator.directive.ts